<script setup>
// @ is an alias to /src
import BookInfo from '@/components/BookInfo'
import AbstractReader from '@/components/AbstractReader'

</script>

<template>
  <div>
    <book-info></book-info>
    <abstract-reader></abstract-reader>
  </div>
</template>
